import { Component } from "react";
import PropTypes from "prop-types";

// formaters and other
import { moneyFormater } from "../../../../utilities/formaters";
import { applicationEmploymentStatuses } from "admin/shared/dictionary/enums";
import { dictRender, boolRender } from "../Applications.Component";

export default class Kalp extends Component {
  maybeRedStyle(cond) {
    return cond ? { backgroundColor: "#ffcccb" } : {};
  }

  render() {
    let application = this.props.CreditApplication;
    return (
      <div>
        <h3>KALP</h3>
        <table className="cs-list-table">
          <tbody>
            <tr>
              <td>Credits monthly costs</td>
              <td>
                {application.MonthlyCreditCosts
                  ? moneyFormater(application.MonthlyCreditCosts) + " kr"
                  : "not set"}
              </td>
            </tr>
            <tr>
              <td>Employed months</td>
              <td>
                {application.EmploymentTimeMonths
                  ? application.EmploymentTimeMonths
                  : "not set"}
              </td>
            </tr>
            <tr
              style={this.maybeRedStyle(
                application.EmploymentStatus == "Unemployed",
              )}
            >
              <td>Employment status</td>
              <td>
                {dictRender(
                  application.EmploymentStatus,
                  applicationEmploymentStatuses,
                )}
              </td>
            </tr>
            <tr style={this.maybeRedStyle(application.IsPep)}>
              <td>Is Pep</td>
              <td>
                <span>{boolRender(application.IsPep)}</span>
              </td>
            </tr>
            <tr>
              <td>Living costs (old)</td>
              <td>
                {application.MonthlyLivingCosts != null &&
                application.MonthlyLivingCosts >= 0
                  ? moneyFormater(application.MonthlyLivingCosts) + " kr"
                  : "not set"}
              </td>
            </tr>
            <tr>
              <td>Housing costs</td>
              <td>
                {application.MonthlyHousingCosts != null &&
                application.MonthlyHousingCosts >= 0
                  ? moneyFormater(application.MonthlyHousingCosts) + " kr"
                  : "not set"}
              </td>
            </tr>
            <tr>
              <td>Income</td>
              <td>
                {application.Income
                  ? moneyFormater(application.Income) + " kr"
                  : "not set"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  static propTypes = {
    application: PropTypes.object,
  };
}
